// extracted by mini-css-extract-plugin
export var contents = "style-module--contents--ff100";
export var description = "style-module--description--27a75";
export var name = "style-module--name--0da7d";
export var profile = "style-module--profile--20fa1";
export var title = "style-module--title--d4ad2";